export const validation = {
  headingMaxChar: 30,
  gallery: {
    min: 1,
    max: 6
  }
}